<template>
  <div class="ls-select-tab-box">
    <div class="table-box">
      <div class="ls-select-search-box">
        <div class="search-item">
          <el-input v-model="search.username" placeholder="请输入账号" clearable />
        </div>
        <div class="search-item">
          <el-input v-model="search.realName" placeholder="请输入姓名" clearable />
        </div>
      </div>
      <div class="table-main">
        <div class="table-content">
          <el-table
            ref="recUserTable"
            :data="tableData"
            :row-key="nodeKey"
            size="default"
            style="width: 100%"
            height="100%"
            class="ls-table"
            border
            stripe
            show-overflow-tooltip
            empty-text="暂无数据"
            :row-class-name="setRowClass"
            :header-cell-class-name="cellClass"
            @select="rowSelect"
          >
            <el-table-column
              :show-overflow-tooltip="false"
              type="selection"
              width="50"
              align="center"
              :selectable="selectable"
              fixed
            />
            <el-table-column label="账号" prop="username" width="150"></el-table-column>
            <el-table-column label="姓名" prop="realName" width="150"></el-table-column>
            <el-table-column label="信息">
              <template #default="{ row }">
                <div class="ls-table-info-box">
                  <span>手机号 : {{ row.mobile ? row.mobile : "--" }}</span>
                  <span>座机号 : {{ row.telephone ? row.telephone : "--" }}</span>
                  <span>邮箱 : {{ row.email ? row.email : "--" }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import request from "../../../api/request";
export default {
  name: 'UserSelectRec',
  components: {
    
  },
  props: {
    multiple: {
      type: Boolean,
      default: true
    },
    selections: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      search: {
        username: "",
        realName: ""
      },
      tableData: [],
      nodeKey: "userId"
    }
  },
  mounted() {
    this.getUserTable();
  },
  watch: {
    selections: {
      deep: true,
      handler() {
        this.setTableSelection(this.selections, this.nodeKey);
      }
    },
  },
  methods: {
    /*获取最近所选人员列表*/
    async getUserTable() {
      try {
        // const { success, message, data } = await lsfetch.get("/api-type/base/conf/his-users", {});
        const { success, message, data } = await request({
          url: "/api-type/base/conf/his-users",
          method: "get",
        });
        // const { success, message, data } = { success:false, message:"111", data:[]}
        if (!success) {
          return this.$message.error("获取最近选择人员失败:" + message);
        }
        let temp = [];
        if (data && data.length) {
          temp = data;
        }
        this.tableData = temp;
      } catch (e) {
        this.$message.error("获取最近选择人员失败:" + e.message || e);
      }
    },

    /*单选时将表头的checkbox隐藏*/
    cellClass(row) {
      if (row.columnIndex === 0 && !this.multiple) {
        return "disabledCheck";
      }
    },

    /*点击选择框*/
    rowSelect(selection) {
      //单选
      if (!this.multiple) {
        if (selection.length > 1) {
          const del_row = selection.shift();
          this.$refs.recUserTable.toggleRowSelection(del_row, false); //用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
        }
        this.$emit("single");
      }
    },

    /*最近人员表格筛选*/
    setRowClass({ row }) {
      // const username = lstool.trim(this.search.username);
      // const realName = lstool.trim(this.search.realName);
      const username = this.search.username;
      const realName = this.search.realName;
      if (username && realName) {
        if (row.username.indexOf(username) > -1 && row.realName.indexOf(realName) > -1) {
          return "row-show";
        } else {
          return "row-hide";
        }
      } else {
        if (username) {
          if (row.username.indexOf(username) > -1) {
            return "row-show";
          } else {
            return "row-hide";
          }
        } else if (realName) {
          if (row.realName.indexOf(realName) > -1) {
            return "row-show";
          } else {
            return "row-hide";
          }
        } else {
          //账号和姓名搜索框都没输入
          return "row-show";
        }
      }
    },

    /*返回被选中的行*/
    getSelections() {
      return this.$refs.recUserTable.selection;
    },

    /*重新设置表格选中状态*/
    setTableSelection(selections, key) {
      this.tableData.map((row) => {
        const result = selections.find((item) => row[key] == item[key]);
        if (result) {
          this.$refs.recUserTable.toggleRowSelection(row, true);
        }
      });
    },

    /*设置表格选中/取消选中*/
    toggleRowSelection(selections, key, flag) {
      selections.map((item) => {
        const result = this.tableData.find((row) => row[key] == item);
        if (result) {
          this.$refs.recUserTable.toggleRowSelection(result, flag);
        }
      });
    },

    /*设置表格行能否选择*/
    selectable(row) {
      const data = this.selections.find((item) => item[this.nodeKey] === row[this.nodeKey]);
      return !data;
    },

    /*清空表格选中*/
    clearTableSelection() {
      this.tableData.map((row) => {
        this.$refs.recUserTable.toggleRowSelection(row, false);
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.ls-select-tab-box {
  width: 100%;
  height: 100%;

  > .table-box {
    flex: 1;
    height: 100%;

    > .ls-select-search-box {
      border-left: 1px solid var(--ls-ui-user-select-border-color);
      border-right: 1px solid var(--ls-ui-user-select-border-color);
    }

    > .table-main {
      width: 100%;
      height: calc(100% - 62px);

      > .table-content {
        width: 100%;
        height: 100%;

        .ls-table {
          ::v-deep(.disabledCheck) {
            .cell {
              .el-checkbox {
                display: none;
              }
            }
          }
        }

        ::v-deep(.el-table) {
          .row-show {
            display: table-row;
          }

          .row-hide {
            display: none;
          }
        }
      }
    }
  }
}

.ls-table-info-box {
  overflow: hidden;

  > span {
    margin-left: 10px;

    &:first-child {
      margin-left: 0;
    }
  }
}
</style>
